import React, { useCallback, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { carousel } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function MaterialCarousel() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [active, setActive] = useState(0);
  const scrollTo = useCallback((index: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(carousel.length - 1, index));
    const card = track.children[clamped] as HTMLElement | undefined;
    if (card) {
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
    }
    setActive(clamped);
  }, []);
  const handleScroll = useCallback(() => {
    const track = trackRef.current;
    if (!track) return;
    const children = Array.from(track.children) as HTMLElement[];
    const nearest = children.reduce((best, el, index) => {
      const distance = Math.abs(el.offsetLeft - track.offsetLeft - track.scrollLeft);
      return distance < best.distance ? {
        index,
        distance
      } : best;
    }, {
      index: 0,
      distance: Number.POSITIVE_INFINITY
    });
    setActive(nearest.index);
  }, []);
  return <section aria-labelledby="muestra" className="w-full bg-ink-raised" data-id="element-102" data-mp="2vgs54vvqkeab">
      <div className="mx-auto max-w-content px-5 py-16 lg:py-24" data-id="element-103" data-mp="2qmxsudign1l9">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-104" data-mp="35c2b1up995td">
          <SectionHeading eyebrow="Muestra interna del material" title="Hojea el material desde adentro" subtitle="Páginas reales del manual, desde los protocolos de inducción hasta las tablas de discernimiento." data-id="element-105" data-mp="30eagsu1517m0" />

          <div className="flex gap-2" data-id="element-106" data-mp="3abyglydlp5b1">
            <button type="button" onClick={() => scrollTo(active - 1)} disabled={active === 0} aria-label="Ver página anterior" className="flex h-11 w-11 items-center justify-center rounded-full border border-line text-cream transition-colors duration-150 ease-out hover:border-amethyst hover:text-amethyst disabled:opacity-35 disabled:hover:border-line disabled:hover:text-cream" data-id="element-107" data-mp="3aczoxv38fdp2">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-108" data-mp="3k2tfoqyjdllt" />
            </button>
            <button type="button" onClick={() => scrollTo(active + 1)} disabled={active === carousel.length - 1} aria-label="Ver página siguiente" className="flex h-11 w-11 items-center justify-center rounded-full border border-line text-cream transition-colors duration-150 ease-out hover:border-amethyst hover:text-amethyst disabled:opacity-35 disabled:hover:border-line disabled:hover:text-cream" data-id="element-109" data-mp="3p0bomhck00tt">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-110" data-mp="bnjcffiwuacg" />
            </button>
          </div>
        </div>

        <ul ref={trackRef} onScroll={handleScroll} className="hide-scrollbar mt-10 flex snap-x snap-mandatory gap-5 overflow-x-auto pb-2" data-id="element-111" data-mp="gkjny5yj45ay">
          {carousel.map(page => <li key={page.title} className="flex w-[85%] shrink-0 snap-start flex-col overflow-hidden rounded-2xl border border-line bg-ink sm:w-[52%] lg:w-[38%]" data-id="element-112" data-mp="pn17udqpolus">
              <img src={page.image} alt={`Página del manual: ${page.title}`} className="aspect-[4/3] w-full object-cover" loading="lazy" data-id="element-113" data-mp="262ghm08gwxhr" />
              <div className="flex flex-1 flex-col p-6" data-id="element-114" data-mp="214ewzave8q46">
                <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-amethyst" data-id="element-115" data-mp="1w4945rde0xki">
                  {page.tag}
                </p>
                <h3 className="mt-3 font-display text-2xl leading-snug text-cream" data-id="element-116" data-mp="2tqpzir2k913m">
                  {page.title}
                </h3>
                <p className="mt-3 text-[14px] leading-relaxed text-muted" data-id="element-117" data-mp="2ovam208gt77q">{page.detail}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-6 flex justify-center gap-2" data-id="element-118" data-mp="2f3wqg3jmwrjv">
          {carousel.map((page, index) => <button key={page.title} type="button" onClick={() => scrollTo(index)} aria-label={`Ir a la página ${index + 1}`} aria-current={index === active} className={`h-1.5 rounded-full transition-[width,background-color] duration-200 ease-out ${index === active ? 'w-8 bg-gold' : 'w-3 bg-line hover:bg-amethyst'}`} data-id="element-119" data-mp="3cj0xc6icy8uv" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}